import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      width="27"
      height="27"
      viewBox="0 0 27 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22.5334 7.60957L16.8592 1.93535C16.701 1.77715 16.4874 1.6875 16.2633 1.6875H5.0625C4.5958 1.6875 4.21875 2.06455 4.21875 2.53125V24.4688C4.21875 24.9354 4.5958 25.3125 5.0625 25.3125H21.9375C22.4042 25.3125 22.7812 24.9354 22.7812 24.4688V8.20811C22.7812 7.98398 22.6916 7.76777 22.5334 7.60957ZM20.8354 8.5957H15.873V3.6334L20.8354 8.5957ZM20.8828 23.4141H6.11719V3.58594H14.0801V9.28125C14.0801 9.57496 14.1968 9.85663 14.4044 10.0643C14.6121 10.272 14.8938 10.3887 15.1875 10.3887H20.8828V23.4141ZM13.2891 16.2949H8.4375C8.32148 16.2949 8.22656 16.3898 8.22656 16.5059V17.7715C8.22656 17.8875 8.32148 17.9824 8.4375 17.9824H13.2891C13.4051 17.9824 13.5 17.8875 13.5 17.7715V16.5059C13.5 16.3898 13.4051 16.2949 13.2891 16.2949ZM8.22656 12.9199V14.1855C8.22656 14.3016 8.32148 14.3965 8.4375 14.3965H18.5625C18.6785 14.3965 18.7734 14.3016 18.7734 14.1855V12.9199C18.7734 12.8039 18.6785 12.709 18.5625 12.709H8.4375C8.32148 12.709 8.22656 12.8039 8.22656 12.9199Z"
        fill="#F1A240"
      />
    </svg>
  );
};

export default memo(Icon);
